import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMotive = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 961.07 416.55",
	style: { enableBackground: "new 0 0 961.07 416.55" },
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\n	.st0{display:none;}\n	.st1{display:inline;fill:#FFFFFF;}\n"
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "background__x28_1:1_x29_",
			className: "st0",
			children: /* @__PURE__ */ _jsx("rect", {
				className: "st1",
				width: 961.07,
				height: 416.55
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "Motive",
			children: /* @__PURE__ */ _jsxs("g", { children: [
				/* @__PURE__ */ _jsx("path", { d: "M514.67,262.28v-67.75h27.72v-27.48h-27.72v-40.71h-31.54v40.71H465.2v27.48h17.93v95.84h59.27v-28.08h-27.73V262.28z" }),
				/* @__PURE__ */ _jsx("path", { d: "M243.97,167.05h-37.69l-56.37,95.24h-27.55v28.08h44.05l46.13-77.91v77.91h37.1l45.89-78.15v78.15h31.54V167.05h-37.81 l-45.29,76.47L243.97,167.05L243.97,167.05z" }),
				/* @__PURE__ */ _jsx("path", { d: "M587.33,167.05h-31.55l0,0v123.32l0,0h31.55l0,0V167.05L587.33,167.05z" }),
				/* @__PURE__ */ _jsx("path", { d: "M587.28,126.34h-31.47v28.08h31.47V126.34z" }),
				/* @__PURE__ */ _jsx("path", { d: "M401.19,165.62h-0.24c-33.94,0-61.18,28.2-61.18,63.09s27.25,63.09,61.18,63.09h0.24c33.94,0,60.95-28.44,60.95-63.09 S435.13,165.62,401.19,165.62z M401.19,260.26h-0.24c-16.73,0-29.63-14.1-29.63-31.55s12.9-31.52,29.63-31.52h0.24 c16.25,0,29.42,14.34,29.42,31.54C430.59,246.16,417.69,260.26,401.19,260.26z" }),
				/* @__PURE__ */ _jsx("path", { d: "M782.31,263.81c12.68,0,20.57-7.42,22.73-13.88l0,0c0.03,0,31.54,0,31.58,0l0,0c-1.2,10.29-14.84,41.87-54.31,41.87 c-35.65,0-61.97-26.8-61.97-63.16c0-35.65,27.03-63.17,61.01-63.17c32.3,0,57.42,28.23,57.42,62.69c0,3.59-0.24,6.94-0.48,9.33 l0,0h-85.63l0,0C754.8,252.56,763.89,263.81,782.31,263.81z M753.6,214.99h54.06l0,0c-3.35-12.42-11.72-21.53-26.32-21.53 C766.06,193.46,757.19,202.32,753.6,214.99L753.6,214.99z" }),
				/* @__PURE__ */ _jsx("path", { d: "M692.57,167.07l-30.08,80.69c-0.01,0.02-0.04,0.02-0.05,0l-30.08-80.69c0-0.01-0.01-0.02-0.03-0.02H598.7 c-0.02,0-0.03,0.02-0.03,0.04l47.78,123.27c0,0.01,0.01,0.02,0.03,0.02h31.75c0.01,0,0.02-0.01,0.03-0.02l48.02-123.27 c0.01-0.02-0.01-0.04-0.03-0.04H692.6C692.59,167.05,692.58,167.06,692.57,167.07z" })
			] })
		})
	]
});
export default SvgMotive;
